<template>
  <div>
    <!--添加维修记录-->
    <el-dialog :visible.sync="addRepairRecordDialogVisible" title="添加维修记录" @close="feedBack" v-if="addRepairRecordDialogVisible">
      <el-form label-width="110px" :model="AddRepairRecord.params" :ref="AddRepairRecord.params" :rules="rulesOfAddRepairRecord">
        <el-form-item label="关联报修记录" prop="reportRecordId" v-show="reportRecordIdNotChoosen">
          <!--<el-input v-model="AddRepairRecord.params.reportRecordId"></el-input>-->
          <el-select placeholder="关联报修记录" class="handle_input" v-model="AddRepairRecord.params.reportRecordId" @click.native="getReportRecordList"
                     filterable clearable style="width: 100%">
            <el-option
              v-for="item in reportRecordList.result.reportRecordList"
              :label="item.reportTitle" :value="item._id">
              <span style="float: left">{{ item.reportTitle }}</span>
<!--              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pointName }}</span>-->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="警维点" prop="alarmPointId" v-if="alarmPointId !== null" >
          <!--<el-input v-model="AddRepairRecord.params.alarmPointId"></el-input>-->
          <!--<el-select v-if="alarmPointId === null" placeholder="警报点" class="handle_input" v-model="AddRepairRecord.params.alarmPointId" @click.native="getAlarmPointList"-->
                     <!--filterable clearable style="width: 100%">-->
            <!--<el-option-->
              <!--v-for="item in alarmPointList.result.alarmPointList"-->
              <!--:label="item.pointName" :value="item._id"></el-option>-->
          <!--</el-select>-->
          <el-tag >{{pointName}}</el-tag>
        </el-form-item>
        <el-form-item label="维修时间" prop="repairTime">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" v-model="AddRepairRecord.params.repairTime" style="width: 100%"></el-date-picker>
        </el-form-item>
<!--        <el-form-item label="维修人" prop="repairerId">-->
<!--          &lt;!&ndash;<el-input v-model="AddRepairRecord.params.repairerId"></el-input>&ndash;&gt;-->
<!--          <el-select placeholder="维修人" class="handle_input" v-model="AddRepairRecord.params.repairerId" @click.native="getUserList"-->
<!--                     filterable clearable style="width: 100%">-->
<!--            <el-option-->
<!--              v-for="item in userList.result.userList"-->
<!--              :label="item.name"-->
<!--              :value="item._id"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="维修内容" prop="repairContent">
          <el-input type="textarea" :rows="2" placeholder="请输入维修内容..." v-model="AddRepairRecord.params.repairContent"></el-input>
        </el-form-item>
        <el-form-item label="是否解决" prop="flag">
          <el-select v-model="AddRepairRecord.params.flag">
            <el-option :value="true" label="解决"></el-option>
            <el-option :value="false" label="未解决"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="checkAddRepairRecord">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddRepairRecord',
  props: ['addRepairRecordDialogVisible', 'reportRecordId', 'alarmPointId', 'pointName'],
  data(){
    return{
      reportRecordIdNotChoosen: true,
      alarmPointNotChoosen: true,
      rulesOfAddRepairRecord:{
        reportRecordId:[{required: true, message:'关联报修记录不能为空', trigger: 'change'}],
        // alarmPointId: [{required: true, message:'警维点编号不能为空', trigger: 'change'}],
        repairTime: [{required: true, message:'维修时间不能为空', trigger: 'change'}],
        // repairerId:[{required: true, message:'维修人不能为空', trigger: 'change'}],
        repairContent:[{required: true, message:'维修内容不能为空', trigger: 'change'}],
        flag:[{required: true, message:'请选择是否解决', trigger: 'change'}],
        // flag:false
      },
      // 添加维修记录
      AddRepairRecord:{
        "version": 1,
        "method": "repair.AddRepairRecord",
        "params": {
          "reportRecordId":"",
          "alarmPointId": "",
          "repairTime": "",
          "repairerId":"",
          "repairContent":"",
          "flag":null
        },
        "token": "#",
        "id": 0
      },
      // 获取警报点列表
      GetAlarmPointList:{
        "version": 1,
        "method": "alarmpoint.GetAlarmPointList",
        "params": {
          "pointName":null,
          "alarmPointType":null,
          "areaId":null
        },
        "token": "#",
        "id": 0
      },
      // 警报点列表
      alarmPointList:{
        "version": 1,
        "result":{
          "alarmPointList": [
            {
              "alarmPointId":  "",
              "pointName": "",
              "alarmPointType": "",
              "longitude": "",
              "latitude": "",
              "alarmRadius":"",
              "areaId":"",
              "installAt":"",
              "remark":""
            },
          ]
        },
        "id": 0
      },
      // 获取用户列表
      GetUserList:{
        "version": 1,
        "method": "user.GetUserList",
        "params": {
          "username":"",
          "name":"",
          "role":""
        },
        "token": "",
        "id": 0
      },
      // 账户列表
      userList:{
        "version": 1,
        "result":{
          "userList":[],
        },
        "id": 0
      },
      // 获得报修记录列表
      GetReportRecordList:{
        "version": 1,
        "method": "report.GetReportTitle",
        "params": {},
        "token": "#",
        "id": 0
  },
      // 报修记录列表
      reportRecordList:{
        "version": 1,
        "result":{
          "reportRecordList": [
            {
              "reportRecordId":"",
              "alarmPointId": "",
              "reporterId": "",
              "reportTime": "",
              "reportContent": "",
              "flag":""
              // "repairRecordIdList":[1,2,3,..]
            },
          ]
        },
        "id": 0
      },
    }
  },
  methods: {
    checkAddRepairRecord(){
      this.$refs[this.AddRepairRecord.params].validate((valid)=>{
        if(valid){
          this.addRepairRecord();
        }
        else{
          return false;
        }
      })
    },
    addRepairRecord(){
      this.AddRepairRecord.token = this.$store.state.token;
      this.AddRepairRecord.params.repairerId = localStorage.getItem('userId');
      if(this.alarmPointId === null){
        // 传来的alarmPointId 为空，从维修界面传来，警报点编号是选择报修后绑定的
        this.reportRecordList.result.reportRecordList.forEach(item =>{
          if(item._id === this.AddRepairRecord.params.reportRecordId){
            this.AddRepairRecord.params.alarmPointId = item.alarmPointId;
          }
        })
      }
      else{
        // 从报修传来，警报点编号已固定，直接赋值
        this.AddRepairRecord.params.alarmPointId = this.alarmPointId;
      }
      console.log('添加维修记录请求');
      console.log(this.AddRepairRecord);
      this.$axios.post(this.$mainUrl, this.AddRepairRecord).then(res=>{
        console.log('添加维修记录请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type: 'success',
            message: '添加维修记录成功'
          })
          this.feedBack();
        }else{
          this.$message({
            type: 'error',
            message: '添加维修记录失败，' + res.data.error.message
          })
        }
      })
    },
    feedBack(){
      this.cleanArguments(this.AddRepairRecord.params);
      this.resetValidate(this.AddRepairRecord.params);
      this.addRepairRecordDialogVisible = false;
      this.$emit('feedBack',this.addRepairRecordDialogVisible);
    },
    // 获取用户列表
    getUserList(){
      for(let key in this.GetUserList.params){
        if(this.GetUserList.params[key] === ""){
          this.GetUserList.params[key] = null;
        }
      }
      this.GetUserList.token = this.$store.state.token;
      console.log('获取用户列表请求');
      console.log(this.GetUserList);
      this.$axios.post(this.$mainUrl, this.GetUserList).then(res =>{
        console.log('获取用户列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.userList = res.data;
        }else{
          this.$message({
            type:'error',
            message:'获取用户列表失败，' + res.data.error.message
          })
        }
      })

    },
    // 获取警报点列表
    getAlarmPointList(){
      for (let val in this.GetAlarmPointList.params){
        if(this.GetAlarmPointList.params[val] === ""){
          this.GetAlarmPointList.params[val] = null;
        }
      }
      this.GetAlarmPointList.token = this.$store.state.token;
      console.log('获取警报点列表请求');
      console.log(this.GetAlarmPointList);
      this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
        console.log('获取警报点列表请求得到响应');
        console.log(res.data);
        this.alarmPointList = res.data;
      })
    },
    // 获取报修记录
    getReportRecordList(){
      for(let key in this.GetReportRecordList.params){
        if(this.GetReportRecordList.params[key] === ""){
          this.GetReportRecordList.params[key] = null;
        }
      }
      this.GetReportRecordList.token = this.$store.state.token;
      console.log('获取报修记录请求');
      console.log(this.GetReportRecordList);
      this.$axios.post(this.$mainUrl, this.GetReportRecordList).then(res=>{
        console.log('获取报修记录请求得到响应')
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.reportRecordList.result.reportRecordList = res.data.result.reportTitleList;
        }else{
          this.$message({
            type: 'error',
            message: '获取报修记录失败，' + res.data.error.message
          })
        }
      })
    },

  },
  watch:{
    addRepairRecordDialogVisible(newValue, oldValue){
      // 如果是从报修界面过来，则传来的报修ID不为空，此时不需要选择报修
      if(this.reportRecordId !== null){
        this.AddRepairRecord.params.reportRecordId = this.reportRecordId;
        this.reportRecordIdNotChoosen = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
